import React from 'react'
import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import SellerOutboundReturnStatusBadge from 'domains/seller-outbound-return/atoms/status-badge'
import SellerOutboundReturnTypeBadge from 'domains/seller-outbound-return/atoms/return-type-badge'
import { STATUS, RETURN_TYPE } from 'domains/seller-outbound-return/constants'
import SelectTableFilter from 'components/atoms/select-table-filter'
import TimeUtil from 'utils/time-util'

const propTypes = {
  rowButtonProps: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled : PropTypes.func,
      colour     : PropTypes.string,
      onClick    : PropTypes.func,
      text       : PropTypes.string
    })
  )
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Columns definition for Seller Product Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const sellerOutboundReturnTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {

  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const ReturnTypeFilter = ({ column }) => {
    const options = Object.keys(RETURN_TYPE).map((key) => (
      {
        label : RETURN_TYPE[key],
        value : RETURN_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const StatusCell     = (row) => <SellerOutboundReturnStatusBadge status={ row.cell.value } />
  const ReturnTypeCell = (row) => <SellerOutboundReturnTypeBadge return_type={ row.cell.value } />

  const DateCell = (row) => TimeUtil.format(row.cell.value)

  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <>
        <RowButton
          data={ row.original }
          color={ buttonColour }
          disabled={ disabled }
          onClick={ onButtonClick }
          text={ buttonText }
        />
      </>
    )
  }

  StatusFilter.propTypes     = filterPropTypes
  ReturnTypeFilter.propTypes = filterPropTypes
  ActionCell.propTypes       = actionCellPropTypes

  return (
    [
      {
        Header  : 'Seller Outbound Return',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header   : 'Code',
            accessor : 'code'
          },
          {
            Header         : 'Total Quantity',
            accessor       : 'total_quantity',
            disableFilters : true
          },
          {
            Header   : 'Return Type',
            accessor : 'return_type',
            Filter   : ReturnTypeFilter,
            Cell     : ReturnTypeCell
          },
          {
            Header   : 'Status',
            accessor : 'status',
            Filter   : StatusFilter,
            Cell     : StatusCell
          },
          {
            Header         : 'Created At',
            accessor       : 'created_at',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header  : 'Seller',
        columns : [
          {
            Header   : 'Code',
            accessor : 'seller.code',
            id       : 'seller_code'
          },
          {
            Header   : 'Name',
            accessor : 'seller.name',
            id       : 'seller_name'
          },
          {
            Header         : 'Email',
            accessor       : 'seller.email',
            disableFilters : true
          }
        ]
      },
      {
        Header         : 'Action',
        accessor       : 'action',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

sellerOutboundReturnTableColumns.propTypes = propTypes

export default sellerOutboundReturnTableColumns
